module.exports = __webpack_public_path__ + "img/white-wooden-kitchen-island-3264485.2e02e9a8.jpg";